import { ERROR, LOADING, SUCCESS, SUCCESS_ONTIME } from './DueDatePerformanceActions';

const INITIAL_STATE = {
  isLoading: true,
  success: false,
  error: '',
  data: [],
  ontimeData: [],
};

const DueDatePerformanceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ERROR: {
      return { ...state, error: action.error };
    }
    case LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case SUCCESS: {
      return { ...state, isLoading: false, data: action.data };
    }
    case SUCCESS_ONTIME: {
      return { ...state, ontimeData: action.data };
    }
    default:
      return state;
  }
};

export default DueDatePerformanceReducer;
